import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = { class: "border border-gray-200 rounded-lg shadow-sm bg-white py-2" }
const _hoisted_4 = { class: "flex flex-col gap-1 px-2" }
const _hoisted_5 = {
  key: 0,
  class: "p-2.5 text-gray-900"
}
const _hoisted_6 = ["onClick"]

import { computed, ref } from "vue"
import GgmsInput from "@/components/GgmsInput.vue"
import { SearchIcon, ArrowLeftIcon } from "@heroicons/vue/outline"
import { Attribute } from "@/shared/models/attributes"
import { useGridCollectionStore } from "@/stores/grid-collection"


export default /*#__PURE__*/_defineComponent({
  __name: 'AttributeList',
  emits: ["onAttributeSelect", "cancel"],
  setup(__props, { emit: __emit }) {

const gridCollectionStore = useGridCollectionStore()

const emit = __emit

const searchQuery = ref("")
const prototypes = computed(() => gridCollectionStore.prototypes)
const canGoBack = computed(() => gridCollectionStore.collectionTypeHistory.length > 1)

function getFilteredAttributes(attributes: Attribute[]) {
    return attributes.filter((attribute) =>
        attribute.displayName.toLowerCase().includes(searchQuery.value.toLowerCase())
    )
}

function selectAttribute(attribute: Attribute) {
    emit("onAttributeSelect", attribute)
}

function cancelFilter() {
    emit("cancel")
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (canGoBack.value)
        ? (_openBlock(), _createBlock(_unref(ArrowLeftIcon), {
            key: 0,
            class: "h-6 w-6 text-primary-color-700 cursor-pointer shrink-0",
            onClick: _withModifiers(cancelFilter, ["stop"])
          }))
        : _createCommentVNode("", true),
      _createVNode(GgmsInput, {
        modelValue: searchQuery.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
        iconStart: _unref(SearchIcon),
        placeholder: "Search",
        class: "w-full"
      }, null, 8, ["modelValue", "iconStart"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prototypes.value, (prototype) => {
        return (_openBlock(), _createElementBlock("div", {
          key: prototype.typeName
        }, [
          _createElementVNode("div", _hoisted_4, [
            (getFilteredAttributes(prototype.attributes).length === 0 && searchQuery.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " No results "))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(getFilteredAttributes(prototype.attributes), (attribute) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: attribute._id,
                    class: "p-2.5 text-gray-900 cursor-pointer hover:bg-gray-100 rounded-lg",
                    onClick: _withModifiers(($event: any) => (selectAttribute(attribute)), ["stop"])
                  }, _toDisplayString(attribute.displayName), 9, _hoisted_6))
                }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})